import React from "react";
import { Tbody, ExpandableTr, EmptyCellContent } from "./Table.style";
import TableRow from "./TableRow";

/**
 * TableBody – renders data rows and optional expandable content.
 */
export default function TableBody({
  data = [],
  columns,
  rowKey = "id",
  rowSelection,
  actions,
  onRowClick,
  expandable,
  striped = true,
  emptyMessage,
  colCount,
}) {
  const getKey = (row, index) => {
    if (typeof rowKey === "function") return rowKey(row);
    return row[rowKey] ?? row.id ?? String(index);
  };

  const selectedSet = new Set(rowSelection?.selectedRowKeys ?? []);
  const expandedSet = new Set(expandable?.expandedRowKeys ?? []);

  const handleSelect = (key, checked) => {
    if (!rowSelection?.onChange) return;
    const next = checked
      ? [...rowSelection.selectedRowKeys, key]
      : rowSelection.selectedRowKeys.filter((k) => k !== key);
    rowSelection.onChange(next);
  };

  if (data.length === 0 && emptyMessage != null) {
    return (
      <Tbody>
        <tr>
          <td colSpan={colCount ?? columns.length + (rowSelection ? 1 : 0) + (actions?.length ? 1 : 0)}>
            <EmptyCellContent>{emptyMessage}</EmptyCellContent>
          </td>
        </tr>
      </Tbody>
    );
  }

  return (
    <Tbody>
      {data.map((row, i) => {
        const key = getKey(row, i);
        const isExpanded = expandable && expandedSet.has(key);
        return (
          <React.Fragment key={key}>
            <TableRow
              row={row}
              rowIndex={i}
              columns={columns}
              rowKey={rowKey}
              isSelected={selectedSet.has(key)}
              onSelect={rowSelection ? handleSelect : undefined}
              actions={actions}
              onRowClick={onRowClick}
              striped={striped}
            />
            {expandable && isExpanded && (
              <ExpandableTr>
                <td colSpan={columns.length + (rowSelection ? 1 : 0) + (actions?.length ? 1 : 0)}>
                  {expandable.renderExpanded(row)}
                </td>
              </ExpandableTr>
            )}
          </React.Fragment>
        );
      })}
    </Tbody>
  );
}
